import { useEffect } from "react";

export function GoogleAnalytics() {
  useEffect(() => {
    // Create the script element for Google Tag Manager
    const script1 = document.createElement("script");
    script1.src = "https://www.googletagmanager.com/gtag/js?id=G-1LW64TGQYZ";
    script1.async = true;
    document.head.appendChild(script1);

    // Create the script element for Google Analytics
    const script2 = document.createElement("script");
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){window.dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-1LW64TGQYZ');
    `;
    document.head.appendChild(script2);

    // Clean up on unmount
    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);

  return null;
}
